import styled from "styled-components";
import { motion } from "framer-motion";

export const HeaderHomeBar = styled(motion.div)`
  display: none;
  position: relative;
  width: 100%;
  height: 74px;
  margin: 0;
  color: var(--color-white);
  background-color: var(--color-latex10);
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-top: 4px solid var(--color-primary);
  flex-shrink: 0;
  padding: 8px 15px;

  .title {
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    font-style: normal;
  }
  .title-negrita {
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    font-style: normal;
  }

  .title-pregunta {
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    font-style: normal;
  }

  h1 {
    padding: 0;
    margin: 0;
    text-align: center;
  }
  .container-ellipse {
    width: 100%;
    height: max-content;
    position: absolute;
    bottom: -50%;
    margin: auto;
    right: 0;
  }
  .arrow {
    font-size: 40px;
    position: absolute;
    left: 0;
    padding-left: 10px;
    cursor: pointer;
  }
  @media (max-width: 1024px) {
    display: flex;
  }
  ::after {
    content: "";
    position: absolute;
    width: 100%;
    left: 0;
    height: 20px;
    bottom: -9px;
    z-index: 10;
    border-radius: 50%;
    background-color: var(--color-latex10);
  }
`;
